<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 会员管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                        @click="handleAdd"
                        class="handle-del mr10"
                        icon="el-icon-delete"
                        type="primary"
                >添加用户
                </el-button>-->
                <el-select class="handle-select mr10" placeholder="搜索方式" v-model="search.type">
                    <el-option
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-for="item in SearchType">
                    </el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="关键字" v-model="search.skey"></el-input>
                <el-button @click="getSearch" icon="el-icon-search" type="success">搜索</el-button>
                <el-button @click="getLoginData" icon="el-icon-user" style="margin-right: 20px;" type="warning">近2日登录
                </el-button>
                <el-badge
                        :value="daishenhe"
                        class="auth-badge"
                        type="danger">
                    <el-button @click="getUserByState(0,1)" icon="el-icon-user">等待同业审核</el-button>
                </el-badge>
                <el-badge
                        :value="daishiming"
                        class="auth-badge"
                        type="warning">
                    <el-button @click="getUserByState(1,1)" icon="el-icon-user">等待实名审核</el-button>
                </el-badge>
                <el-badge
                        :value="yirenzheng"
                        class="auth-badge"
                        type="primary">
                    <el-button @click="getUserByState(2,1)" icon="el-icon-user">已认证的同业</el-button>
                </el-badge>
                <el-badge
                        :value="weirenzheng"
                        class="auth-badge"
                        type="info">
                    <el-button @click="getUserByState(3,1)" icon="el-icon-user">未认证的用户</el-button>
                </el-badge>
                <el-badge
                        :value="yishiming"
                        class="auth-badge"
                        type="success">
                    <el-button @click="getUserByState(4,1)" icon="el-icon-user">已认实名的同业</el-button>
                </el-badge>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="id" width="55"></el-table-column>

                <!-- <el-table-column prop="uemail" label="用户邮箱" width="200" align="center"></el-table-column> -->
                <el-table-column align="left" label="微信名称" width="230">
                    <template slot-scope="scope">
                        <div class="wechat-name-wrapper">
                            <!-- 认证状态徽章 -->
                            <el-badge
                                    :hidden="false"
                                    class="auth-badge"
                                    type="danger"
                                    v-if="scope.row.uprivt === 1"
                                    value="等待认证"
                            >
                                <span class="name-text">{{ scope.row.profile.usn }}</span>
                            </el-badge>
                            <!-- 普通状态文本 -->
                            <span class="name-text" v-else>{{ scope.row.profile.usn }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="姓名" width="150">
                    <template slot-scope="scope">
                        <div class="wechat-name-wrapper">
                            <!-- 认证状态徽章 -->
                            <el-badge
                                    :hidden="false"
                                    class="auth-badge"
                                    type="warning"
                                    v-if="scope.row.uidstate === 1"
                                    value="等待审核"
                            >
                                <span class="name-text">{{ scope.row.profile.uname }}</span>
                            </el-badge>
                            <!-- 普通状态文本 -->
                            <span class="name-text" v-else>{{ scope.row.profile.uname }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="手机" prop="profile.uphone" width="120"></el-table-column>
                <el-table-column align="center" label="最近登录" prop="utime" width="160"></el-table-column>
                <el-table-column align="center" label="等级" width="180">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.uprivt===0?'danger':(scope.row.uprivt===1?'info':(scope.row.uprivt===5?'success':(scope.row.uprivt===8?'danger':'warn')))">
                            {{scope.row.uprivt===0?'未认证':(scope.row.uprivt===1?'等待审核':(scope.row.uprivt===5?'认证的同业':(scope.row.uprivt===8?'管理员':'系统管理员')))}}
                        </el-tag>

                        <el-tag
                                :type="scope.row.uidstate===0?'danger':(scope.row.uidstate===1?'info':'success')">
                            {{scope.row.uidstate===0?'未实名':(scope.row.uidstate===1?'实名审核中':'已实名')}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="注册时间" prop="profile.ujoin_time" width="180"></el-table-column>
                <!--                <el-table-column align="center" label="所属城市" prop="city.Cname"></el-table-column>-->
                <el-table-column align="center" label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.ustate===1?'success':(scope.row.ustate===0?'danger':'')"
                        >{{scope.row.ustate===1?'正常':(scope.row.ustate===0?'禁用':'')}}
                        </el-tag>
                    </template>
                </el-table-column>

                <!--                <el-table-column align="center" label="邀请人" prop="uvcode" width="150"></el-table-column>-->
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button
                                @click="updateinfo(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="updatePrivt(scope.$index, scope.row)"
                                class="red"
                                icon="el-icon-unlock"
                                type="text"
                        >权限
                        </el-button>
                        <el-button
                                @click="updateidinfo(scope.$index, scope.row)"
                                icon="el-icon-edit-outline"
                                type="text"
                        >手机
                        </el-button>
                        <el-button
                                @click="updateCertificate(scope.$index, scope.row)"
                                icon="el-icon-document-checked"
                                type="text"
                        >同业
                        </el-button>
                        <el-button
                                @click="updateAuthen(scope.$index, scope.row)"
                                icon="el-icon-warning-outline"
                                type="text"
                        >实名
                        </el-button>
                        <el-button
                                @click="loginHistory(scope.row)"
                                class="green"
                                icon="el-icon-view"
                                type="text"
                        >历史
                        </el-button>
                        <!--<el-button
                                @click="updatePass(scope.$index, scope.row)"
                                icon="el-icon-magic-stick"
                                type="text"
                        >密码
                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 用户拥有目的地权限修改 -->
        <el-dialog :visible.sync="privtVisible" title="编辑目的地权限" width="40%">
            <el-form :model="form" label-width="80px" ref="formRef">
                <div :key="item.id" class="permission-row" v-for="item in userDests">
                    <div class="city-name">{{item.Cname}}</div>
                    <div class="permission-group">
                        <el-checkbox v-model="item.Scenic">景点</el-checkbox>
                        <el-checkbox v-model="item.Hotel">酒店</el-checkbox>
                        <el-checkbox v-model="item.Trip">线路</el-checkbox>
                        <el-checkbox v-model="item.Vehicle">用车</el-checkbox>
                    </div>
                    <div class="form-fields">
                        <el-form-item class="validity-item" label="有效期">
                            <el-input class='wd200' v-model="item.Expired"></el-input>
                        </el-form-item>
                        <el-form-item class="validity-item" label="VIP状态码">
                            <el-input class='wd200' placeholder="景-酒-车-线" v-model="item.State"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="VIP状态" class="vip-item">
                            <el-select v-model="item.State" placeholder="请选择">
                                <el-option
                                        v-for="opt in privtStateOpt"
                                        :key="opt.value"
                                        :label="opt.label"
                                        :value="opt.value">
                                </el-option>
                            </el-select>
                        </el-form-item>-->
                    </div>
                </div>
            </el-form>
            <span class="dialog-footer" slot="footer" v-if="query.role>7">
                <el-button @click="privtVisible = false">取 消</el-button>
                <el-button @click="updateUserPrivt" type="primary">确 定</el-button>
            </span>

        </el-dialog>
        <!-- 用户手机-邮箱修改 -->
        <el-dialog :visible.sync="editVisible" title="编辑手机/邮箱" width="40%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-form-item label="手机号码">
                    <el-input v-model="formUser.uphone"></el-input>
                </el-form-item>
                <el-form-item label="邮箱地址">
                    <el-input v-model="form.uemail"></el-input>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer" v-if="query.role>7">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="updateUser" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 用户个人资料修改 -->
        <el-dialog :visible.sync="addVisible" title="添加/编辑用户" width="40%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="姓名">
                            <el-input class='wd200' v-model="formUser.uname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="昵称">
                            <el-input class='wd200' v-model="formUser.usn"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="微信号">
                            <el-input class='wd200' v-model="formUser.uwechat"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="性别">
                            <el-radio-group v-model="formUser.usex">
                                <el-radio :label="0">女</el-radio>
                                <el-radio :label="1">男</el-radio>
                                <!--                                <el-radio :label="2">保密</el-radio>-->
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="生日">
                            <el-date-picker class="wd200"
                                            placeholder="选择日期"
                                            type="date"
                                            v-model="formUser.ubirth">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="所属城市">
                            <el-input class='wd200' v-model="formUser.ufrom_city"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="身份证号">
                            <el-input class='wd200' v-model="formUser.urealid"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="实名状态">
                            <el-select placeholder="请选择" v-model="form.uidstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           class="wd200"
                                           v-for="item in idstateOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="认证状态">
                            <el-select placeholder="请选择" v-model="form.uprivt">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           class="wd200"
                                           v-for="item in privtOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="职业">
                            <el-select placeholder="请选择" v-model="formUser.ucareer">
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in careerOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="目的地">
                            <el-select
                                    default-first-option
                                    filterable
                                    multiple
                                    placeholder="请选择授权目的地"
                                    v-model="userCitys">
                                <el-option
                                        :key="item.Id"
                                        :label="item.Cname"
                                        :value="item.Id"
                                        v-for="item in destCitys">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="账号状态">
                            <el-select placeholder="请选择" v-model="form.ustate">
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in stateOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="邀请码">{{form.uacode}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邀请人">{{form.uvpersonId}}【{{form.uvperson}}】</el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span class="dialog-footer" slot="footer" v-if="query.role>7">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button @click="saveAdd" type="primary">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 登录历史 弹出框 -->
        <el-dialog :visible.sync="loginVisible" title="查看登录历史" width="40%">
            <template>
                <el-table
                        :data="loginData"
                        style="width: 100%">
                    <el-table-column
                            label="登录序号"
                            prop="id"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            label="登录时间"
                            prop="login_time"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            label="登录Ip"
                            prop="login_ip">
                    </el-table-column>
                </el-table>
            </template>

            <span class="dialog-footer" slot="footer">
                <el-button @click="loginVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 编辑 修改密码框 -->
        <el-dialog :visible.sync="passVisible" title="修改密码（ 正常密码，无需加密！）" width="40%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-form-item label="手机号码">
                    <el-input :disabled="true" v-model="formUser.uphone"></el-input>
                </el-form-item>
                <el-form-item label="新的密码">
                    <el-input clearable v-model="form.upass"></el-input>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="passVisible = false">取 消</el-button>
                <el-button @click="updatePwd" type="primary">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 弹出框@编辑展示 同业资质信息 -->
        <el-dialog :model="formUser" :title="'【 '+formUser.uname+' 】 的 （ 从业资质 ）证明文件'" :visible.sync="certificateVisible"
                   width="80%">
            <el-upload
                    :before-remove="beforeRemove"
                    :before-upload="beforeAvatarUpload"
                    :file-list="fileList"
                    :http-request="upload"
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    action=""
                    list-type="picture">
                <i class="el-icon-plus"></i>
            </el-upload>
        </el-dialog>

        <!-- 弹出框@编辑展示 同业资质信息 -->
        <el-dialog :model="formUser" :title="'【 '+formUser.uname+' 】 的 （ 实名制 ）文件'" :visible.sync="authenVisible"
                   width="80%">
            <el-upload
                    :before-remove="beforeRemove"
                    :before-upload="beforeAvatarUpload"
                    :file-list="fileList"
                    :http-request="upload"
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    action=""
                    list-type="picture">
                <i class="el-icon-plus"></i>
            </el-upload>
        </el-dialog>

        <!-- 点击图片展示详情   -->
        <el-dialog :visible.sync="picture_Visible" title="详情展示" width="80%">
            <img :src="picture_ImageUrl" alt="" width="100%">
        </el-dialog>

    </div>
</template>

<script>

    export default {
        name: 'basetable',
        data() {
            return {
                SearchType: [
                    { name: '微信名称', id: '1' },
                    { name: '姓名', id: '2' },
                    { name: '手机', id: '3' }
                ],
                privtStateOpt: [
                    { value: 0, label: '未认证' },
                    { value: 1, label: '已认证' },
                    { value: 2, label: '付费VIP' }
                ],
                idstateOpt: [
                    { value: 0, label: '未实名' },
                    { value: 1, label: '实名审核中' },
                    { value: 2, label: '已实名认证' }
                ],
                careerOpt: [
                    { value: 0, label: '计调/操作' },
                    { value: 1, label: '销售/客服' },
                    { value: 2, label: '导游/领队' },
                    { value: 3, label: '车队/司机' },
                    { value: 4, label: '酒店/民宿' },
                    { value: 5, label: '旅游定制师' },
                    { value: 6, label: '其他' }
                ],
                query: {
                    pageIndex: 1,
                    pageSize: 15,
                    cityid: 17,
                    role: 0,
                    day: ''
                },
                search: {
                    skey: '',
                    type: '2',
                    cid: ''
                },
                privtOpt: [{
                    value: 5,
                    label: '认证正常'
                }, {
                    value: 1,
                    label: '等待认证审核'
                }, {
                    value: 0,
                    label: '未认证'
                }],
                stateOpt: [{
                    value: 0,
                    label: '已禁用'
                }, {
                    value: 1,
                    label: '正常'
                }],

                destCitys: [],  // 下拉展示目的地列表
                userCitys: [],  // 用户本身拥有的目的地 列表 ID
                userDests: [],  // 用户本身拥有的目的地 列表 ID
                tableData: [],
                loginData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                addVisible: false,
                loginVisible: false,
                passVisible: false,
                privtVisible: false,
                certificateVisible: false,
                certificate_Visible: false,
                authenVisible: false,
                authen_Visible: false,
                policy_ImageUrl: '',
                picture_ImageUrl: '',
                picture_Visible: false,

                fileList: [],
                image_type: 1,
                pageTotal: 0,
                form: {},
                formUser: {},
                dests: {},
                idx: -1,
                id: -1,
                daishenhe: 0,
                daishiming: 0,
                yirenzheng: 0,
                weirenzheng: 0,
                yishiming: 0
            };
        },
        created() {
            // this.reload();
            this.getData();
            this.query.cityid = sessionStorage.getItem('ml_cityid');
            this.query.role = sessionStorage.getItem('ml_role');
        },
        components: {
            'remote-js': {
                render(createElement) {
                    return createElement('script', { attrs: { type: 'text/javascript', src: this.src } });
                },
                props: {
                    src: { type: String, required: true }
                }
            }
        },

        methods: {
            async getData() {
                const { data: res } = await this.$http.post('admin/member/initUserData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.tableData = res.data.list;
                this.pageTotal = res.data.pageTotal || 15;
                this.daishenhe = res.tyReview,
                this.daishiming = res.smReview,
                this.yirenzheng = res.ytyReview,
                this.yishiming = res.ysmReview,
                this.weirenzheng = res.wrzReview,
                this.$message.success('【会员列表】数据加载成功!');
            },

            async getSearch() {
                if (this.search.skey.length < 1) {
                    return this.$message.error('请输入检索关键字!');
                } else {
                    this.search.cid = 17;
                    const { data: res } = await this.$http.post('admin/member/searchUser', {
                        search: this.search
                    });
                    if (res.code !== 200) {
                        return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                    }
                    this.tableData = res.list;
                    this.pageTotal = res.pageTotal || 25;
                    this.$message.success('数据加载成功!');
                }
            },

            async getLoginData() {
                this.query.day = 1;
                const { data: res } = await this.$http.post('admin/member/initUserData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.tableData = res.data.list;
                this.pageTotal = res.data.pageTotal || 25;
                this.$message.success('【LoginUserData列表】数据加载成功!');
            },

            async getUserByState(type,pageIndex) {
                if(pageIndex!=null){
                    this.query.pageIndex=pageIndex;
                }
                this.query.type = type;
                const { data: res } = await this.$http.post('admin/member/getUserByState', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误亦或权限问题，请联系管理员!' + res.code);
                }
                this.tableData = res.data.list;
                this.pageTotal = res.data.pageTotal || 15;
                this.$message.success('【列表'+type+'】数据加载成功!');
            },

            // 触发搜索按钮
            handleSearch() {
                this.$set(this.query, 'pageIndex', 1);
                this.getData();
            },
            // 删除操作
            handleDelete(index, row) {
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.$message.success('删除成功');
                        this.tableData.splice(index, 1);
                    })
                    .catch(() => {
                    });
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },
            // 新增操作  -暂不使用
            handleAdd() {
                this.addVisible = true;
                this.form.id = '';
                // this.formUser = '';

            },
            // // 新增或修改用户信息
            async saveAdd() {
                //this.formUser.ujoin_ip = returnCitySN['cip'];
                const { data: res } = await this.$http.post('/admin/member/addUser', {
                    form: this.form,
                    formUser: this.formUser,
                    userCitys: this.userCitys
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，用户操作失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
            },

            //更新用户密码信息
            async updatePwd() {
                let user = { 'id': this.form.id, 'pass': this.form.upass };
                const { data: res } = await this.$http.post('/admin/member/updatePwd', user);
                if (res.code !== 200) {
                    this.passVisible = true;
                    return this.$message.error(res.message);
                } else {
                    this.passVisible = false;
                    this.$message.success(res.message);
                }
                // this.addVisible = false;
            },

            //更新用户账号信息
            async updateUserPrivt() {
                const privtData = this.prepareSubPrivtData();
                const { data: res } = await this.$http.post('/admin/member/updateUserPrivt', privtData);
                if (res.code !== 200) {

                    return this.$message.error(res.message);
                } else {
                    this.privtVisible = false;
                    this.$message.success(res.message);
                }
            },
            // 权限修改 数据 预提交
            prepareSubPrivtData() {
                return this.userDests.map(city => ({
                    Id: city.Id,
                    Cname: city.Cname,
                    Scenic: city.Scenic,
                    Hotel: city.Hotel,
                    Trip: city.Trip,
                    Vehicle: city.Vehicle,
                    State: city.State,
                    Expired: city.Expired
                }));
            },

            //更新用户账号信息
            async updateUser() {
                let user = { 'id': this.form.id, 'email': this.form.uemail, 'phone': this.formUser.uphone };
                const { data: res } = await this.$http.post('/admin/member/updateUserId', user);
                if (res.code !== 200) {
                    this.editVisible = true;
                    return this.$message.error(res.message);
                } else {
                    this.editVisible = true;
                    this.$message.success(res.message);
                }
                // this.addVisible = false;
            },
            // 编辑基本信息操作
            async updateinfo(index, row) {
                this.idx = index;
                this.form = row;
                this.formUser = row.profile;
                this.addVisible = true;
                const { data: res } = await this.$http.post('/admin/index/getDestCity', {
                    type: '2'
                });
                this.destCitys = res.list;

                const { data: userDest } = await this.$http.post('/admin/member/getUserDest', {
                    uid: this.form.id
                });
                this.userCitys = userDest.listId;
            },
            // 编辑账号 权限信息操作
            async updatePrivt(index, row) {
                this.idx = index;
                this.form = row;
                // this.formUser = row.profile;
                this.privtVisible = true;
                const { data: userDest } = await this.$http.post('/admin/member/getUserDest', {
                    uid: this.form.id
                });
                this.userDests = userDest.list;
            },

            // 编辑账号信息操作
            updateidinfo(index, row) {
                this.idx = index;
                this.form = row;
                this.formUser = row.profile;
                this.editVisible = true;
            },

            // 编辑 密码
            updatePass(index, row) {
                this.idx = index;
                this.form = row;
                this.formUser = row.profile;
                this.passVisible = true;
            },
            //显示登录历史
            async loginHistory(row) {

                const { data: res } = await this.$http.post('/admin/member/loginHistroy', {
                    user: row.profile
                });
                if (res.code !== 200) {
                    //this.loginVisible = true;
                    return this.$message.error(res.message);
                } else {
                    this.loginVisible = true;
                    this.loginData = res.list;
                    this.$message.success(res.message);
                }
            },
            // 保存编辑
            saveEdit() {
                this.editVisible = false;
                this.$message.success(`修改第 ${this.idx + 1} 行成功`);
                this.$set(this.tableData, this.idx, this.form);
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                let type=this.query.type;
                if(type){
                    this.getUserByState(type)
                }else{
                    this.getData();
                }

            },

            //上传文件
            async upload(param) {
                const formData = new FormData();
                formData.append('file', param.file);
                formData.append('pid', this.form.id);
                formData.append('uname', this.formUser.uname + '/' + this.formUser.usn);
                //formData.append('city', this.cityName);
                formData.append('image_type', this.image_type);
                const { data: res } = await this.$http.post('/admin/common/upload_img', formData);
                if (res.code !== 200) {
                    return this.$message.error('系统错误，图片文件上传失败，请联系管理员!');
                }
                this.$message.success('【图片/文件】上传成功!');
            },

            //上传前的检查判断
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === 'image/gif' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('仅支持gif,jpg,png格式的图片！');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!' + isLt2M);
                }
                return isJPG && isLt2M;
            },
            // 删除当前图片前的确认
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 删除当前图片
            async handleRemove(file, fileList) {
                const { data: res } = await this.$http.post('/admin/common/updateImages', {
                    id: file.id
                });
                this.$message.success('【图片/文件】移除成功!');
            },
            handlePictureCardPreview(file) {
                this.picture_ImageUrl = file.url;
                this.picture_Visible = true;
            },

            //限制上传文件的数量
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },


            // 展示用户 同业资质的文件列表
            async updateCertificate(index, row) {
                this.idx = index;
                this.form = row;
                this.formUser = row.profile;
                this.certificateVisible = true;
                const { data: res } = await this.$http.post('/admin/scenics/getImages', {
                    pid: this.form.id,
                    type: '7'
                });
                this.image_type = '7';
                this.fileList = res;
            },

            // 展示用户 实名认证的文件列表
            async updateAuthen(index, row) {
                this.idx = index;
                this.form = row;
                this.formUser = row.profile;
                this.authenVisible = true;
                const { data: res } = await this.$http.post('/admin/common/getImages', {
                    pid: this.form.id,
                    type: '6'
                });
                this.image_type = '6';
                this.fileList = res;
            }
        }
    };
</script>

<style scoped>

    .wechat-name-wrapper {
        display: inline-flex;
        align-items: center;
        min-width: 0; /* 修复flex容器文本溢出问题 */
    }

    .auth-badge {
        margin-top: 10px;
        margin-right: 40px;
        flex-shrink: 0; /* 防止徽章被压缩 */
    }

    .name-text {
        color: #333;
        font-size: 14px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .item {
        margin-top: 10px;
        margin-right: 40px;
    }

    .wd200 {
        width: 220px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .green {
        color: #00a854;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .permission-row {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        padding: 10px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
    }

    .city-name {
        width: 70px;
        font-weight: bold;
        line-height: 36px;
    }

    .permission-group {
        flex: 1;
        display: flex;
    }

    .permission-group .el-checkbox {
        margin-right: 15px;
    }

    .form-fields {
        width: 100%;
        display: flex;
        margin-top: 10px;
    }

    .validity-item {
        flex: 1;
        margin-right: 10px;
    }

    .vip-item {
        flex: 1;
    }

    .wd200 {
        width: 200px;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
    }
</style>
